class TabInactive extends HTMLElement {
  constructor() {
    super();
    this.originalTitle = document.title;
    this.inactiveMessage = this.getAttribute('message');
  }

  connectedCallback() {
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  }

  disconnectedCallback() {
    document.removeEventListener('visibilitychange', this.handleVisibilityChange);
  }

  handleVisibilityChange = () => {
    if (!this.inactiveMessage) return;
    if (document.hidden) {
      setTimeout(() => {
        if (document.hidden) {
          document.title = this.inactiveMessage;
        }
      }, 1500);
    } else {
      document.title = this.originalTitle;
    }
  };
}

customElements.define('tab-inactive', TabInactive);
